<template>
<router-view />
</template>

<script>
export default {
  name: 'DataDisplay',
  routeInfo: {
    label: '数据展示'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/index.vue